var _rect, _path, _path2, _path3, _path4, _path5, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaw(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 74.0002,
    height: 74,
    rx: 37,
    fill: "#E3DBFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8476 29.1692C27.1789 25.8062 24.8583 22.9629 22.0834 22.9629C19.31 22.9629 17.5 26.6283 17.5 30.0567C17.5 33.4852 20.4921 36.1172 23.2657 36.1172C26.0422 36.1172 28.5862 32.8636 27.8476 29.1693V29.1692Z",
    fill: "#927BF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0083 32.0275C35.6798 32.769 39.0049 30.3209 39.2861 26.5627C39.5383 23.1435 38.0735 19.7807 35.3957 19.0356C32.7211 18.291 29.9978 21.3394 29.0816 24.6417C28.1621 27.9456 30.3367 31.2811 33.0083 32.0275Z",
    fill: "#927BF7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9707 33.3919C51.5921 30.3708 51.6196 26.7021 49.4752 24.9366C47.3401 23.1678 43.6107 24.847 41.4253 27.4928C39.2415 30.134 39.8736 34.0669 42.0164 35.836C44.1564 37.6017 48.1881 36.7143 49.9708 33.3923L49.9707 33.3919Z",
    fill: "#927BF7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1148 37.9081C56.0068 35.6438 52.2898 35.6288 49.4908 36.9964C46.6915 38.3612 45.7325 41.8548 46.8405 44.1208C47.9485 46.3883 51.6215 47.1691 54.3451 45.095C56.8251 43.2026 58.2218 40.1755 57.1154 37.9083L57.1148 37.9081Z",
    fill: "#927BF7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.24 34.193C28.5993 33.7812 20.3125 38.8205 20.3125 44.9857C20.3125 51.1511 27.4037 55.9728 34.0583 56.075C44.3316 56.2209 46.5821 50.8245 45.4422 44.7641C44.2568 38.4832 39.9711 34.4909 35.2406 34.193H35.24Z",
    fill: "#927BF7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 74.0002,
    height: 74,
    rx: 37,
    stroke: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaw);
export default __webpack_public_path__ + "static/media/paw.130ac88ee4829b48b8a307b03f7c7be9.svg";
export { ForwardRef as ReactComponent };